/**
 * @desc 根据用户编号获取该用户相同角色用户列表
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(params: API.ucenter.sysUserRole.getSameRoleStaff.Params, options?: any) {
  return updateResponse(
    http(URL + `/sysUserRole/getSameRoleUser`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
